var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHomeSidebar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "127px",
    viewBox: "0 0 128 127",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home---Side-Menu",
    transform: "translate(-10.000000, -11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UB---Side-Menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "casa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "casa",
    transform: "translate(20.000000, 47.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.723828,42.436875 L61.8419531,0.789140625 C60.7450781,-0.013828125 59.2549219,-0.013828125 58.1585156,0.789140625 L1.27617187,42.436875 C-0.113203125,43.4542969 -0.415078125,45.4052344 0.60234375,46.7946094 C1.61976562,48.1839844 3.5709375,48.4853906 4.96007812,47.4684375 L60,7.1690625 L115.039922,47.4682031 C115.594922,47.8748438 116.239922,48.0707142 116.879297,48.0707142 C117.839297,48.0707142 118.786641,47.62875 119.397422,46.794375 C120.415078,45.4052344 120.113203,43.4542969 118.723828,42.436875 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.651406,48.1741406 C101.929687,48.1741406 100.533516,49.5700781 100.533516,51.2920313 L100.533516,100.920703 L75.5908594,100.920703 L75.5908594,73.8302344 C75.5908594,65.2333594 68.5966406,58.2396094 60.0002344,58.2396094 C51.4038281,58.2396094 44.4096094,65.2338281 44.4096094,73.8302344 L44.4096094,100.920937 L19.4667187,100.920937 L19.4667187,51.2922656 C19.4667187,49.5703125 18.0705469,48.1741406 16.3488281,48.1741406 C14.6271094,48.1741406 13.2309375,49.5703125 13.2309375,51.2922656 L13.2309375,104.039062 C13.2309375,105.761016 14.6271094,107.156953 16.3488281,107.156953 L47.5275,107.156953 C49.1671875,107.156953 50.5089844,105.890156 50.6332031,104.281875 C50.6407031,104.208984 50.6453906,104.129297 50.6453906,104.039062 L50.6453906,73.8304687 C50.6453906,68.6721094 54.841875,64.475625 60.0002344,64.475625 C65.1585937,64.475625 69.3550781,68.6723437 69.3550781,73.8304687 L69.3550781,104.039062 C69.3550781,104.128828 69.3597656,104.207109 69.3672656,104.279062 C69.4900781,105.888516 70.8323437,107.156953 72.4729687,107.156953 L103.651641,107.156953 C105.373594,107.156953 106.769531,105.761016 106.769531,104.039062 L106.769531,51.2922656 C106.769531,49.5700781 105.373359,48.1741406 103.651406,48.1741406 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("text", {
    id: "HOME",
    fontFamily: "NHaasGroteskTXPro-Bd, Neue Haas Grotesk Text Pro",
    fontSize: 12.5,
    fontWeight: "bold",
    letterSpacing: -0.181818,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "HOME")))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHomeSidebar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home-sidebar.685f0213.svg";
export { ForwardRef as ReactComponent };